export class DateUtil {
  static toDateOnly(date: Date | null): string | null {
    if (!date) return null;

    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');

    return `${y}-${m}-${d}`;
  }
}
